<template>
    <form enctype="multipart/form-data">
        <label for="logo" class="mb-1">{{ $t('organization_details.logo') }}</label>
        <div class="card mb-0" :class="[ form.errors.has('logo') ? 'border-danger-500' : 'input-border-color' ]">
            <div class="card-body px-4">
                <div class="flex flex-col md:flex-row items-center">
                    <div class="mr-4">
                        <organization-logo :organization="organization"></organization-logo>
                    </div>
                    <div>
                        <div class="text-center md:mt-0 md:text-left mt-4">
                            <div v-if="isDemo" class="btn btn-primary disabled mb-3 mr-2" v-tooltip="{ content: $t('globals.action_not_allowed_demo'), placement: 'top' }">
                                {{ $t('organization_details.upload_new_logo') }}
                            </div>
                            <div v-else-if="!userOwnsOrganization" class="btn btn-primary disabled mb-3 mr-2" v-tooltip="{ content: $t('globals.action_not_allowed_not_owner'), placement: 'top' }">
                                {{ $t('organization_details.upload_new_logo') }}
                            </div>
                            <div v-else class="btn btn-primary mb-3 mr-2 relative">
                                <input class="absolute cursor-pointer inset-x-0 inset-y-0 opacity-0" type="file" name="logo" ref="logo" accept="image/*" @change="update">
                                {{ $t('organization_details.upload_new_logo') }}
                            </div>
                            <div v-if="isDemo" class="btn btn-default disabled mb-3 mr-2" @click.prevent v-tooltip="{ content: $t('globals.action_not_allowed_demo'), placement: 'top' }">
                                {{ $t('globals.remove') }}
                            </div>
                            <button v-else-if="!userOwnsOrganization" @click.prevent class="btn btn-default disabled mb-3 mr-2" v-tooltip="{ content: $t('globals.action_not_allowed_not_owner'), placement: 'top' }">
                                {{ $t('globals.remove') }}
                            </button>
                            <button v-else class="btn btn-default mb-3" @click="remove" type="button">
                                {{ $t('globals.remove') }}
                            </button>
                        </div>
                        <p class="mb-0">{{ $t('organization_details.logo_rules') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <p class="help-block text-danger-500" v-if="form.errors.has('logo')" v-text="form.errors.get('logo')"></p>
    </form>
</template>

<script>
export default {
    props: {
        organization: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({}),
        };
    },

    computed: {
        userOwnsOrganization() {
            return window.Globals.user.organization.owner_id === window.Globals.user.id;
        },

        isDemo() {
            return window.Globals.isDemo;
        },
    },

    methods: {
        update(e) {
            e.preventDefault();
            if (! this.$refs.logo.files.length) return;

            const self = this;
            this.form.startProcessing();
            axios.post('/api/v1/organization-logo', this.gatherFormData())
                .then(response => {
                    self.form.finishProcessing();
                    window.location.reload();
                })
                .catch(error => self.form.setErrors(error.response.data.errors));
        },

        remove() {
            axios.delete('/api/v1/organization-logo')
                .then(() => window.location.reload())
                .catch(() => {
                    window.toastr.clear();
                    window.toastr.error(this.$t('globals.unexpected_error'));
                });
        },

        gatherFormData() {
            const data = new FormData();
            data.append('logo', this.$refs.logo.files[0]);

            return data;
        },
    },
};
</script>
